<template>
  <div class="ma-5 ml-3 site_content">
    <div class="flex s-bt">
      <comboFarm
      @fromFarm="farmInfo"
      />
      <img :src="icon_raw" class="raw_icon" @click="RawRouter(farmData)"/>
    </div>

    <div class="air_container mt-10">
      <div class="air_title ml-2">냉방기 정보</div>
      <!-- {{ items }} -->
      <div class="mt-1 air_contents">
        <div class="spinner mb-10 mt-5" v-if="loading"></div>


        <div v-for="(air, a) in items" :key=a class="info_box">
          <div class="info_title">
            <div class="font-semi">{{ air.device_name }}</div>
            
            <div class="eqp_status" v-if="air.mesureval01 !== undefined && air.mesureval01 !== null"
            :class="{
              'mode_offline': disConnect(air.mesuredt),
              'mode_on': !disConnect(air.mesuredt) && air.mesureval01 === 1,
              'mode_off': !disConnect(air.mesuredt) && air.mesureval01 === 0
            }">
              <div v-if="disConnect(air.mesuredt)" class="discon_icon"> <v-icon size="20" color="#828282">mdi-close-network</v-icon></div>
              <div v-else-if="air.mesureval01 == 1"> ON</div>
              <div v-else> OFF</div>
            </div>
          </div>

          <div class="flex mt-2 mb-1" v-if="air.mesureval02 !== undefined && air.mesureval02 !== null"
          :class="{ disabled: disConnect(air.mesuredt) }">
            <div class="mt-2 gauge_box">
              <div class="gauge_bar" :style="{ width: air.mesureval02 + '%' }"></div>
            </div>
            <div class="ml-2 s-font">{{ air.mesureval02 }} %</div>
          </div>

          <div class="info_date mt-1" :class="{ color_red: disConnect(air.mesuredt) }">
            {{ air.mesuredt }}
          </div>
        </div>
      </div>
    </div>

    <div class="farmSensor_container mt-4">
      <div class="flex a-center">
        <div class="air_title">농장 센서 정보</div>
        <button
          class="refresh_btn btn" 
          @click="sensorRefresh()">
        <v-icon color="white" size="20">
          mdi-refresh
        </v-icon>
      </button>
      </div>

      <!-- 센서 정보 -->
      <div class="mt-4">
        <v-data-table dense
          class="table_content v-data-table"
          fixed-header
          :footer-props="{
            itemsPerPageOptions:[-1]
          }"
          :headers="headers"
          :items-per-page="-1" 
          :items="sensor"
          :loading="sensorloadinng"
          no-data-text="측정된 자료가 없습니다."
          item-key="room_name"
          group-by="building_name"
          single-select
          :sort-by= "['room_name']"
          :sort-desc= "[true]"
          hide-default-footer
        >
        <template v-slot:group.header="{items, isOpen, toggle}">
          <th colspan="14">
            <v-icon @click="toggle">
            {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}</v-icon> 
            <span>{{ items[0].building_name }} </span>
          </th>
        </template>

        <template v-slot:item= "{ item }">
          <tr style="text-align: center;">
            <td style="text-align: left;">{{ item.room_name }}</td> 
            <td >{{ item.temp }}</td>
            <td>{{ item.highestTemp }}</td>
            <td>{{ item.lowestTemp }}</td>
            <td>{{ item.hum }}</td>
            <td>{{ item.checkDate }}</td>
            <td>
              <button class="link_btn" @click="gotoBarometer(item)">
                <v-icon color="white" size="22" >
                  mdi-history 
                </v-icon>
              </button>
            </td>
          </tr>
        </template>
      </v-data-table>
      </div>
    </div>


  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import comboFarm from "@/components/combo/farm.vue";

export default {
  name: 'Airconditioner',
  components:{
    comboFarm,
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 


  },

  data(){
    return {
      farmData: { company: {}, farm: {} },
      icon_raw: require("@/assets/pack/raw_data.svg"),

      items:[],
      sensor:[],

      headers: [
        { text: '구역', sortable: true, value: 'room_name' , align:'center' },
        { text: '온도', value: 'temp',align:'center' },
        { text: '최고온도', value: 'highestTemp',align:'center' },
        { text: '최저온도', value: 'lowestTemp',align:'center' },
        { text: '습도', value: 'hum',align:'center' },
        { text: '측정시간', value: 'checkDate',align:'center' },

        { text: '상세보기', value: '',align:'center' },
      ],

      loading:false,
      sensorloadinng:false
      
    }
  },
  methods:{
    async farmInfo(data){
      this.farmData = data;

      this.items = [];

      this.airRefresh();
      this.sensorRefresh()
    },
    RawRouter(farmData){
      // console.log(farmData)
      // this.$router.push({
      //   name: "rawData",
      //   params: { 
      //     farm:{code: farmData.farm.code, name: farmData.farm.name},
      //     typeCode: "EC08"
      //     // type:{code:'EC08', name:'냉방기'}
      //    }
      // });
      sessionStorage.setItem("pack_farm", JSON.stringify({
        farm: { code: farmData.farm.code, name: farmData.farm.name }
      }));

      this.$router.push({
        name: "rawData",
        params: { 
          typeCode: "EC08" 
        }
      });
    },
    disConnect(con){
      if (!con) return true

      const now = new Date()
      const measured = new Date(con.replace(' ', 'T'))
      const minute = (now - measured) / 1000 / 60

      return minute >= 30
    },
    airRefresh(){
      this.loading = true;

      Apis.monitorEC08dataOfPackageInFarm({
        farm_cd : this.farmData.farm.code,
      },(res) => {  
        if (res.result) {
        this.items = res.data;

        this.$store.commit("resMessage",res.message);
      } else {
        this.loading = false;
        alert(res.message);
      }
        this.loading = false;
      }).catch( (err) => {  // API 오류 처리
          console.log("monitorEC08dataOfPackageInFarm API 호출 오류",err)
          this.loading = false;
      })
    },
    sensorRefresh(){
      this.sensorloadinng = true;

      Apis.monitoringSummary({
        "farm_cd" : this.farmData.farm.code,
        "building_cd" : "",
        "stand_dt" : dateUtil.format(new Date(), "yyyy-MM-dd HH:mm:ss"), 
        "check_list" : ["temp","feel","hum"]
      },(res) => {  
        if (res.result) {
        this.sensor = res.data;

        // console.log(this.sensor)
        this.sensorloadinng = false;

        this.$store.commit("resMessage",res.message);
      } else {
          alert(res.message);
        }
        this.sensorloadinng = false;
      }).catch( (err) => {  // API 오류 처리
          console.log("monitoringSummary API 호출 오류",err)
          this.sensorloadinng = false;
      })
    },
    gotoBarometer(item) {
      sessionStorage.setItem("summaryData",JSON.stringify(this.items));
      // alert('수정중입니다.')
      this.$router.push({
        name: "Barometer",
        params: { 
          company: {code: this.farmData.farm.company_cd, name: this.farmData.farm.company_name},
          farm: {code: this.farmData.farm.code, name: this.farmData.farm.name, biz:this.farmData.farm.biz},
          building: {code: item.building_cd, name: item.building_name},
          room: {code: item.room_cd, name: item.room_name + " " + item.farm_name},
          }
      });
    },

  }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
.air_title{
  font-weight:$bold-weight;
  letter-spacing: $spacing-unit;
  font-size:17px;
}
.air_contents{
  width:100%;
  display: flex;
  flex-wrap: wrap;
}
.info_box{
  background-color: white;
  margin:5px;
  padding:10px;
  border-radius: 15px;
  border:1px solid #E1E1E1;

  width:250px;
}
.info_title{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.eqp_status{
  font-weight:600;
  padding:1px 7px;
  border-radius: 10px;
  width:50px;
  text-align: center;
}
.mode_offline{
  color:gray;
}
.mode_on{
  color:#4CAF50;
  background-color: #E8F5E9;
}
.mode_off{
  color:#F5493D;
  background-color: #FFEBEE;
}
.s-font{
  font-size:14px;
  letter-spacing: -1.25px;
  margin-top:2px;
}
.gauge_box {
  width: 80%;
  height: 10px;
  background: #e5e5e5;
  border-radius: 6px;
  overflow: hidden;
}
.gauge_bar {
  height: 100%;
  background: $main-color; 
  transition: width 0.3s ease;
}
.info_date{
  font-size:13px;
  letter-spacing: -1px;
  color:#adadad;
  text-align: right;
}
.farmSensor_container{
  width:90%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  background: #FFFFFF;
  padding:20px;
}
.btn{
  width:30px !important;
  height:30px !important;
}
.font-semi{
  font-weight:550;
}
.font-m{
  font-size:20px;
  letter-spacing: -1px;
}
.link_btn{
  width:50px !important;
  height:30px !important;
  border-radius: 20px !important;
  background-color: $point-color;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
}
.detail{
  cursor: pointer;
}
.disabled {
  opacity: 0.35;
  filter: grayscale(1);
}

.disabled .gauge_bar {
  background: #a3a3a3;
}
.color_red{
  color:#d01f12
}
.discon_icon{
  margin-right:-20px;
}
@media screen and (max-width: 768px){
  .info_box{
    width:90%;
  }
}
</style>